<!-- Custom registration fields -->
<form #customRegistrationFieldsForm="ngForm" novalidate>
    <div class="custom-registration-fields">
        <div class="row">
            <div class="col mb-2">
                <div class="" *ngIf="customRegistrationFields && customRegistrationFields.length > 0">
                    <div *ngFor="let customRegistrationField of customRegistrationFields">
                        <!-- Simple Text -->
                        <div *ngIf="customRegistrationField.type == CustomRegistrationFieldTypes.SimpleText" class="field-container">
                            <div class="form-group">
                                <label class="input-label" [for]="customRegistrationField.customRegistrationFieldId">{{ translateLabel(customRegistrationField.text, customRegistrationField.text) | async }}</label>
                                <label *ngIf="customRegistrationField.isRequired" class="input-label">*</label>
                                <input type="text"
                                       [(ngModel)]="customRegistrationField.value"
                                       [name]="customRegistrationField.customRegistrationFieldId"
                                       [placeholder]="translateLabel('Enter' + customRegistrationField.text, defaultInputPlaceholder$ | async) | async"
                                       [id]="customRegistrationField.customRegistrationFieldId"
                                       [required]="customRegistrationField.isRequired"
                                       class="form-control" #name="ngModel" />
                                <div *ngIf="name.invalid && (name.dirty || name.touched)" class="alert alert-danger">
                                    <div *ngIf="name.errors.required">
                                        <span [appTranslate]="customRegistrationField.text + 'Required'" role="alert">{{customRegistrationField.text}} is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Boolean -->
                        <div class="field-container" *ngIf="customRegistrationField.type ==  CustomRegistrationFieldTypes.Boolean">
                            <div class="form-group">
                                <label class="input-label" [class]="customRegistrationField.isRequired ? 'required' : ''">{{ customRegistrationField.text }}</label>
                                   <div class="form-check">
                                      <div *ngIf="!customRegistrationField.isRequired">
                                        <input type="radio"
                                                [(ngModel)]="customRegistrationField.value"
                                                [id]="customRegistrationField.customRegistrationFieldId + '-nochoice'"
                                                [name]="customRegistrationField.customRegistrationFieldId"
                                                ng-value="NoChoice" >
                                        <label [appTranslate]="'NoChoice'" [for]="customRegistrationField.customRegistrationFieldId + '-nochoice'">No Choice</label>
                                      </div>
                                       <div>
                                        <input type="radio"
                                               [(ngModel)]="customRegistrationField.value"
                                               [id]="customRegistrationField.customRegistrationFieldId + '-yes' "
                                               [name]="customRegistrationField.customRegistrationFieldId"
                                               value="Yes">
                                        <label [appTranslate]="'Yes'" [for]="customRegistrationField.customRegistrationFieldId + '-yes'">Yes</label>
                                    </div>
                                    <div>
                                        <input type="radio"
                                               [(ngModel)]="customRegistrationField.value"
                                               [id]="customRegistrationField.customRegistrationFieldId + '-no' "
                                               [name]="customRegistrationField.customRegistrationFieldId"
                                               value="No">
                                        <label [appTranslate]="'No'" [for]="customRegistrationField.customRegistrationFieldId + '-no'">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Multiple Choice -->
                        <div class="field-container field-container--dropdown" *ngIf="customRegistrationField.type == CustomRegistrationFieldTypes.MultipleChoice">
                            <div class="form-group">
                                <label class="input-label" [class]="customRegistrationField.isRequired ? 'required' : ''">{{ translateLabel(customRegistrationField.text+ 'Label', customRegistrationField.text) | async }}</label>
                                <select [(ngModel)]="customRegistrationField.value"
                                        [id]="customRegistrationField.customRegistrationFieldId"
                                        [name]="customRegistrationField.customRegistrationFieldId"
                                        [required]="customRegistrationField.isRequired"
                                        class="form-control">
                                    <option
                                        [ngValue]="undefined"
                                        disabled
                                        selected
                                        [appTranslate]="'SelectAnOption'">
                                        Select An Option
                                    </option>
                                    <option *ngFor="let choice of customRegistrationField.choicesArray" [ngValue]="choice">
                                        {{ translateLabel(choice+ 'Label', choice) | async }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Single Choice -->
                        <div class="field-container" *ngIf="customRegistrationField.type == CustomRegistrationFieldTypes.SingleChoice">
                            <div class="form-group">
                                <label class="input-label" [class]="customRegistrationField.isRequired ? 'required' : ''">
                                    {{ translateLabel(customRegistrationField.text+ 'Label', customRegistrationField.text) | async }}
                                </label>
                                <div>
                                    <label>
                                        <input
                                            [required]="customRegistrationField.isRequired"
                                            type="checkbox"
                                            [(ngModel)]="customRegistrationField.value"
                                            [id]="customRegistrationField.customRegistrationFieldId"
                                            [name]="customRegistrationField.customRegistrationFieldId"
                                            #checkboxValue="ngModel"
                                        >
                                        <span class="ml-2" [innerHTML]="translateLabel(customRegistrationField.text +'CheckboxLabel', 'Datenschutz') | async"></span>
                                    </label>
                                </div>
                                <div *ngIf="checkboxValue.invalid && (checkboxValue.dirty || checkboxValue.touched)" class="alert alert-danger">
                                    <div *ngIf="checkboxValue.errors.required">
                                        <span [appTranslate]="customRegistrationField.text + 'Required'" role="alert">{{customRegistrationField.text}} is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

